// synced from loomweb blocks/skill-block-view.tsx (de-Tailwind'd).
/**
 * Skill block. Faithful to loomweb's SkillBlockView: header (icon + "Skill" + the
 * display name + in-progress / Done state), an optional active-text row, and the
 * full skill name. Display name strips a "ns:" prefix, same as upstream. Tailwind
 * classes are replaced by namespaced `replay-*` CSS; lucide icons by the local
 * inline-SVG set.
 */
import type { JSX } from "react";
import type { SkillBlock } from "@shared/loom-message-block";
import { SparklesIcon, LoaderIcon, CheckIcon } from "./icons";

export function SkillBlockView({ block }: { block: SkillBlock }): JSX.Element {
  const isInProgress = block.status === "in_progress" || block.status === "streaming";
  const isCompleted = block.status === "completed";

  const displayName = block.skillName.includes(":")
    ? (block.skillName.split(":").pop() ?? block.skillName)
    : block.skillName;

  return (
    <div className="replay-block replay-skill-block">
      <div className="replay-block-head">
        <SparklesIcon className="replay-icon replay-text-primary" />
        <span className="replay-block-label">Skill</span>
        <span className="replay-skill-name">{displayName}</span>
        {isInProgress && (
          <span className="replay-block-flag replay-text-primary replay-ml-auto">
            <LoaderIcon className="replay-icon-xs replay-spin" />
          </span>
        )}
        {isCompleted && (
          <span className="replay-block-flag replay-text-success replay-ml-auto">
            <CheckIcon className="replay-icon-xs" />
            Done
          </span>
        )}
      </div>

      {isInProgress && block.activeText !== undefined && block.activeText.length > 0 && (
        <div className="replay-block-active">{block.activeText}</div>
      )}

      <div className="replay-skill-body">
        <span className="replay-text-muted replay-mr-1">Using:</span>
        <span className="replay-mono">{block.skillName}</span>
      </div>
    </div>
  );
}
